import { render, staticRenderFns } from "./sourcingRequestContact.vue?vue&type=template&id=0c9b5e81&"
import script from "./sourcingRequestContact.vue?vue&type=script&lang=js&"
export * from "./sourcingRequestContact.vue?vue&type=script&lang=js&"
import style0 from "./sourcingRequestContact.vue?vue&type=style&index=0&id=0c9b5e81&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports